import React, { useEffect } from 'react';
import './App.css';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import { RootLayout } from './components/layout/Root/Root';
import { LoginScreen } from './pages/Login.screen';
import { Toaster } from 'react-hot-toast';
import { ProjectScreen } from './pages/Project.screen';
import { PrivateRoute } from './components/shared/Routes/PrivateRoutes';
import ErrorBoundary from './errors/ErrorBoundry';
import { ConfigurationRoot } from './components/features/ConfigurationRoot/ConfigurationRoot';
import { FeaturesScreen } from './pages/Features.screen';
import { StagingScreen } from './pages/Staging.screen';
import { DatamanagerScreen } from './pages/Datamanager.screen';
import { StyleSheetManager } from 'styled-components';
import { useAppSelector } from './redux/hooks';
import { rootState } from './redux/store';
import CircularPlot from './components/chart/CircularPlot';
import ErrorPage from './pages/ErrorPage';
import { DashboardScreen } from './pages/Dashboard.screen';
import { DashboardConfigScreen } from './pages/DashboardConfig.screen';
import { ROUTES } from './constants/constants';
import { ProjectAdminConfigScreen } from './pages/ProjectAdminConfig.screen';
import {  AiDataExtractorScreen } from './pages/AiDataExtractor.screen';
import { AiDataExtractorPackageDetailsScreen } from './pages/AiDataExtractorPackageDetails.screen';

// Ignore Error ResizeObserver
if (typeof window !== 'undefined') {
    const resizeObserverErrLoop = () => {
        window.console.error = (...args) => {
            if (/ResizeObserver loop limit exceeded/.test(args[0])) {
                return;
            }
        };
    };

    resizeObserverErrLoop();
}

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" errorElement={<ErrorPage />}>
            <Route path="" element={<PrivateRoute redirectTime={5} redirectRoute={`/${ROUTES.PROJECTS}`} isLoggedIn={true} title="Projects" />}>
                <Route index element={<LoginScreen />} />
            </Route>
            <Route path="" element={<PrivateRoute redirectTime={5} redirectRoute={'/'} isLoggedIn={false} title="Log in" />}>
                <Route element={<RootLayout />} errorElement={<ErrorPage />}>
                    <Route path={ROUTES.PROJECTS} index element={<ProjectScreen />} />
                    <Route path={`${ROUTES.PROJECTS}/:projectId/${ROUTES.PROJECT_ADMIN_COFIGURATION}`} index element={<ProjectAdminConfigScreen/>} />
                    <Route path={`${ROUTES.CONFIGURATION}/:projectName`} element={<ConfigurationRoot />} errorElement={<ErrorPage />}>
                        <Route path="*" index element={<div>404 NOT FOUND</div>} />
                        <Route path={ROUTES.DASHBOARD}  element={<DashboardScreen/>} />
                        <Route path={`${ROUTES.DASHBOARD}/node`} index element={<DashboardConfigScreen/>} />
                        <Route path={ROUTES.FEATURES} index element={<FeaturesScreen />} />

                        {/* <Route path={ROUTES.DATAMANAGER}>
                            <Route index element={<div>404 NOT FOUND</div>} />
                            <Route path={ROUTES.DATA_ORGANIZER} element={<DatamanagerScreen />} />
                            <Route path={ROUTES.AI_DATA_EXTRACTOR} >
                                <Route index element={<AiDataExtractorScreen />} />
                                <Route path=":package-details" element={<AiDataExtractorPackageDetailsScreen/>} />
                            </Route>
                        </Route> */}

                        <Route path={ROUTES.DATAMANAGER} element={<DatamanagerScreen />} />


                        <Route path={ROUTES.QGATE} element={<StagingScreen />} />
                    </Route>
                </Route>
            </Route>
            <Route path="*" element={<div>404 NOT FOUND</div>} />
            <Route path={ROUTES.TESTING_AREA} index element={<CircularPlot />} errorElement={<ErrorPage />} />
        </Route>,
    ),
);

function App() {
    const { userAndTokenData } = useAppSelector((state: rootState) => state.loginUserAndTokenData);

    return (
        <>
            <ErrorBoundary>
                {/* <UserSettingsBackgroundLoader/> */}
                <Toaster
                    position="bottom-center"
                    toastOptions={{
                    
                        duration: 3000,
                        style: {
                            fontSize: '1.4rem',
                            borderRadius: '.5rem',
                            maxWidth: 'none', // Uklanja ograničenje širine
                            whiteSpace: 'normal', // Omogućava prelamanje reči u više linija
                            wordWrap: 'break-word', // Prelamanje reči ako je potrebno
                        },
                        error: {
                            style: {
                                border: '1px solid rgba(255,0,0,.5)',
                            },
                        },
                        success: {
                            style: {
                                border: '1px solid rgba(0,255,0,.5)',
                            },
                        },
                    }}
                />

                <StyleSheetManager shouldForwardProp={(prop) => prop !== 'error'}>
                    <RouterProvider router={router} />
                </StyleSheetManager>
            </ErrorBoundary>
        </>
    );
}

export default App;